import PropTypes from 'prop-types';

export const LocaleDefaultProps = {
  localeData: {}
};

export const LocalePropTypes = {
  localeData: PropTypes.objectOf(PropTypes.string)
};

export const LocaleShape = PropTypes.shape(LocalePropTypes);
